import { SuperAdminConstants } from '../../../_constants';

const initialState = { getAssessment_groupListLoading: true, data: '', error: false };

export function getAssessment_groupListReducer(state = initialState, action) {
    
    switch (action.type) {
        case SuperAdminConstants.REQUEST_GET_ASSESSOR_GROUP_LIST:
            return {
                getAssessment_groupListLoading: true,
                data: '',
                error: false
            };
        case SuperAdminConstants.RECEIVE_GET_ASSESSOR_GROUP_LIST:
            return {
                getAssessment_groupListLoading: false,
                data: action,
                error: false
            };
        case SuperAdminConstants.GET_ASSESSOR_GROUP_LIST_ERROR:
            return {
                getAssessment_groupListLoading: false,
                data: '',
                error: true
            };
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/_reducers/SuperAdmin/AssignAssessor/getAssessment_groupList.js